
export const root = {
    background: 'transparent',
    borderColor: '{content.border.color}',
    color: '{content.color}',
    transitionDuration: '{transition.duration}'
};

export const gutter = {
    background: '{content.border.color}',
    size: '4px'
};

export const handle = {
    size: '40px',
    background: 'transparent', // Make handle background transparent
    borderRadius: '4px',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}'
    }
};

export const colorScheme = {
    light: {
        handle: {
            background: 'rgba(0, 0, 0, 0.2)'
        },
        gutter: {
            background: '{surface.border}'
        }
    },
    dark: {
        handle: {
            background: 'rgba(255, 255, 255, 0.3)'
        },
        gutter: {
            background: 'rgba(255, 255, 255, 0.1)',
            hoverBackground: 'rgba(255, 255, 255, 0.2)'
        }
    }
};

export default {
    root,
    gutter,
    handle,
    colorScheme
};
